import type { Translation } from '../translations.types';

const translations: Translation = {
  logout: 'Abmelden',
  notifications: {
    title: 'Benachrichtigungen',
    pageTitle: 'Benachrichtigungen',
    pageDescription: 'Benachrichtigungen verwalten',
    markAllAsRead: 'Alle als gelesen markieren'
  },
  openMenu: 'Menü öffnen',
  closeMenu: 'Menü schließen',
  'media.image': 'Bild',
  'media.video': 'Video',
  author: 'Gepostet von',
  'add-review': 'Mmm! Teile deine Food-Story!',
  'add-review-to-food': 'Erzähle uns von deiner {{food}}-Erfahrung',
  'draft-cleared': 'Entwurf erfolgreich gelöscht!',
  'draft-save-error': 'Hoppla! Dein Entwurf konnte nicht gespeichert werden',
  'clear-draft': 'Entwurf löschen',
  'review-modal-media-explanation': 'Füge Fotos deines Essens hinzu! Gute Fotos helfen anderen Foodies, einen echten Eindruck zu bekommen.',
  'review-modal-rating-explanation': 'Zeit für die Bewertung! Teile deine ehrliche Meinung und Details zum Gericht.',
  'review-modal-location-explanation': 'Wo hast du dieses Essen genossen? Hilf anderen, diesen köstlichen Ort zu finden!',
  'media': 'Fotos',
  'location': 'Standort',
  'rating-explanation': 'Bewerte es! (1 = meh, 10 = umwerfend!)',
  food: {
    title: 'Essen',
    gourmets: '{{food}} Fans',
    bestPlaces: 'Beste Orte für {{food}}',
    gourmetsSectionDescription:
      'Schau dir an, wer sich mit {{food}} auskennt! Unsere Feinschmecker werden danach bewertet, wie oft sie es probiert haben und was sie davon hielten.',
    bestPlacesSectionDescription:
      'Auf der Suche nach erstaunlichem {{food}}? Diese Orte werden von Leuten bewertet, die sich auskennen!',
    beTheFirstReviewer: {
      title: 'Sei der Erste, der {{foodName}} bewertet!',
      description: 'Deine Geschmackserfahrung zählt! Teile deine Bewertung und hilf anderen Feinschmeckern, dieses Gericht zu entdecken.',
      button: 'Erste Bewertung schreiben'
    }
  },
  drink: 'Getränk',
  place: 'Ort',
  'where-did-you-eat': 'Wo hast du das gegessen?',
  'what-did-you-eat': 'Was hast du probiert?',
  localeCurrency: 'Lokale Währung',
  category: 'Kategorie',
  name: 'Name',
  rating: 'Deine Bewertung',
  welcome_modal: {
    title: 'Willkommen bei BiteCritic!',
    subtitle: 'Entdecke deinen nächsten Lieblingsgeschmack',
    description:
      'BiteCritic ist eine Gemeinschaft von Essensliebhabern, die ihre Erfahrungen teilen und das Essen bewerten, das sie probiert haben.',
    features: {
      title: 'Mit BiteCritic kannst du:',
      rate: 'Gerichte nach Geschmack bewerten, nicht nur Restaurants',
      discover:
        'Neue Speisen basierend auf authentischen Bewertungen entdecken',
      connect: 'Dich mit anderen Essensliebhabern verbinden',
      track: 'Speisen verfolgen, die du probieren möchtest',
    },
    not_now: 'Nicht jetzt',
    join_now: 'Jetzt beitreten',
  },
  review: {
    label: 'Deine Bewertung',
    writingIn: 'Ich schreibe diese Bewertung in',
    success: 'Deine Geschichte ist online!',
    error: 'Ups! Beim Teilen deiner Geschichte ist etwas schiefgegangen',
    foodReviewTitle:
      '{{foodName}} Bewertung von {{username}} bei {{placeName}}, {{city}}',
    drinkReviewTitle:
      '{{drinkName}} Bewertung von {{username}} bei {{placeName}}, {{city}}',
  },
  previous: 'Zurück',
  next: 'Weiter',
  'submit-review': 'Teile deine Geschichte',
  cancel: 'Vergiss es',
  type: 'Welche Art',
  'add-food-review': 'Was hast du gegessen?',
  'select-food': 'Wähle dein Gericht',
  cost: 'Wie viel?',
  'write-your-review': 'Erzähl uns alles...',
  'visited-at': 'Wann warst du dort?',
  reviews: {
    noReviews: 'Keine Bewertungen gefunden',
    readFull: 'Lies die ganze Geschichte',
    showTranslation: 'Übersetzung anzeigen',
    showOriginal: 'Original anzeigen',
    translatedFrom: 'Übersetzt aus dem {{language}}',
    filters: {
      title: 'Filter',
      apply: 'Filter anwenden',
      rating: 'Bewertung',
      cost: 'Kosten',
      startDate: 'Von',
      endDate: 'Bis',
      location: 'Standort',
      radius: 'Suchradius (km)',
      sort: {
        label: 'Sortieren nach',
        newest: 'Neueste zuerst',
        oldest: 'Älteste zuerst',
        mostLiked: 'Höchste Bewertung',
        leastLiked: 'Niedrigste Bewertung',
        mostExpensive: 'Teuerste',
        cheapest: 'Günstigste',
      },
      sortOrder: {
        asc: 'aufsteigend',
        desc: 'absteigend',
      },
      sortBy: {
        createdAt: 'Datum',
        likeCount: 'Likes',
        cost: 'Preis',
      },
      active: {
        rating: 'Min. Bewertung: {{value}}',
        startDate: 'Von: {{date}}',
        endDate: 'Bis: {{date}}',
        cost: 'Min. Kosten: {{value}}',
        radius: 'Innerhalb von {{value}}km',
      },
    },
  },
  languages: {
    en: 'Englisch',
    nl: 'Niederländisch',
    tr: 'Türkisch',
    de: 'Deutsch',
    fr: 'Französisch',
    es: 'Spanisch',
    it: 'Italienisch',
    pt: 'Portugiesisch',
    select: 'Sprache auswählen',
  },
  validation: {
    'place-required': 'Hoppla! Wähle zuerst einen Ort',
    'category-required': 'Wähle eine Kategorie!',
    'review-min-length':
      'Etwas mehr Details wären toll (mindestens 80 Zeichen)',
    'rating-required': 'Vergiss nicht, es zu bewerten!',
    'cost-positive': 'Der Preis muss höher als Null sein',
    'visited-at-required': 'Wann warst du dort?',
    'type-required': 'Essen oder Getränk?',
    'food-required': 'Was hast du gegessen?',
    'drink-required': 'Was hast du getrunken?',
    'country-required': 'Woher kommst du?',
    required: 'Dieses Feld ist erforderlich',
  },
  auth: {
    welcomeBack: 'Hallo! 👋',
    loginToContinue: 'Melde dich wieder an',
    continueWithGoogle: 'Weiter mit Google',
    continueWithApple: 'Weiter mit Apple',
    logout: 'Bis später!',
    login: 'Komm rein',
    signup: 'Tritt der Food-Party bei!',
    required: 'Lass uns anfangen!',
    actionRequiresAuth:
      'Hoppla! Für diese Aktion ist eine Anmeldung erforderlich',
    alreadyLoggedIn: 'Du bist bereits angemeldet!',
    goToProfile: 'Zum Profil',
    continueToFeed: 'Zum Feed',
    benefits: {
      title: 'Schau, was du verpasst:',
      follow: 'Behalte deine Lieblingsgerichte im Auge',
      review: 'Teile deine Essensabenteuer',
      save: 'Speichere Orte für später',
      community: 'Triff andere Essensliebhaber',
      personalized: 'Erhalte Essenstipps nur für dich',
    },
    cta: {
      login: "Los geht's!",
      cancel: 'Vielleicht später',
    },
    actions: {
      followFood: 'Schnelle Anmeldung, um diesem leckeren Gericht zu folgen!',
      unfollowFood: 'Anmelden, um nicht mehr zu folgen',
    },
    joinNow: 'Jetzt beitreten!',
    joinCommunity: 'Tritt der Food-Party bei!',
    alreadyHaveAccount: 'Hast du bereits ein Konto?',
    signupToContinue: 'Tritt der Food-Party bei!',
  },
  profile: {
    follow: 'Folgen',
    unfollow: 'Nicht mehr folgen',
    followers: 'Fans',
    following: 'Folgt',
    avatar: 'Dein Bild',
    change_avatar: 'Neues Bild',
    upload_avatar: 'Bild hochladen',
    title: 'Dein Profil',
    view: 'Profil ansehen',
    username: 'Benutzername',
    email: 'E-Mail',
    success: 'Sieht gut aus!',
    error: 'Hoppla, etwas ist schiefgegangen',
    save: 'Speichern',
    firstName: 'Vorname',
    lastName: 'Nachname',
    birthDate: 'Geburtstag',
    country: 'Land',
    bio: 'Über dich',
    bioPlaceholder: 'Erzähl uns von deinen Essensabenteuern...',
    selectCountry: 'Wähle dein Land',
    deleteAccount: {
      button: 'Konto löschen',
      title: 'Dein Konto löschen',
      warning:
        'Warnung: Diese Aktion kann nicht rückgängig gemacht werden. Alle deine Daten, Bewertungen und Einstellungen werden dauerhaft gelöscht.',

      confirm: 'Mein Konto löschen',
      error:
        'Konto konnte nicht gelöscht werden. Bitte versuche es später erneut.',
    },
    noAccount: 'Noch kein Konto?',
  },
  errors: {
    invalidFileType:
      'Ungültiger Dateityp. Bitte lade nur JPG, PNG, WebP, HEIC oder HEIF Bilder hoch.',
    fileTooLarge: 'Datei ist zu groß. Maximale Größe ist {{size}}.',
    tooManyFiles: 'Zu viele Dateien. Maximal erlaubt sind {{max}}.',
  },
  onboarding: {
    welcome: 'Willkommen bei BiteCritic!',
    setup_profile: 'Lass uns dein Profil einrichten',
    username: 'Benutzername',
    username_required: 'Benutzername ist erforderlich',
    username_min_length: 'Benutzername muss mindestens 3 Zeichen lang sein',
    username_pattern: 'Nur Buchstaben, Zahlen und Unterstriche sind erlaubt',
    username_taken: 'Dieser Benutzername ist bereits vergeben',
    username_available: 'Benutzername ist verfügbar!',
    username_requirements:
      'Benutzername muss mindestens 3 Zeichen lang sein und darf nur Buchstaben, Zahlen und Unterstriche enthalten',
    checking_username: 'Überprüfe Verfügbarkeit des Benutzernamens...',
    first_name: 'Vorname',
    first_name_required: 'Vorname ist erforderlich',
    first_name_min_length: 'Vorname muss mindestens 2 Zeichen lang sein',
    first_name_max_length: 'Vorname darf höchstens 20 Zeichen lang sein',
    last_name: 'Nachname',
    last_name_required: 'Nachname ist erforderlich',
    last_name_min_length: 'Nachname muss mindestens 2 Zeichen lang sein',
    last_name_max_length: 'Nachname darf höchstens 20 Zeichen lang sein',
    birth_date: 'Geburtsdatum',
    birth_date_required: 'Geburtsdatum ist erforderlich',
    country: 'Land',
    complete_profile: 'Profil vervollständigen',
    success: 'Profil erfolgreich aktualisiert!',
    error: 'Fehler beim Aktualisieren des Profils',
  },
  language: {
    select: 'Wähle deine Sprache',
    select_country: 'Wo bist du?',
    select_language: 'Welche Sprache?',
    current: 'Aktuelle Sprache',
  },
  categories: {
    title: 'Essenskategorien',
    meta: {
      title: 'Essenskategorien - Entdecke kulinarische Köstlichkeiten',
      description:
        'Entdecke unsere vielfältigen Essenskategorien und kulinarische Köstlichkeiten aus aller Welt. Finde Bewertungen, Ratings und wo du sie genießen kannst.',
      categoryTitle: 'Essenskategorie',
      categoryDescription:
        'Entdecke {{category}} - Finde {{count}} köstliche Gerichte in dieser Kategorie mit Bewertungen von Essensliebhabern.',
      keywords:
        'Essenskategorien, Küchenarten, kulinarische Erkundung, Essensentdeckung',
      loading: 'Lade Kategorie',
      defaultDescription:
        'Entdecke unsere vielfältigen Essenskategorien und finde dein nächstes kulinarisches Abenteuer.',
    },
  },
  common: {
    noMoreReviews: 'Keine weiteren Bewertungen',
    save: 'Speichern',
    error: {
      default: 'Hoppla!',
      fetchFailed: 'Daten konnten nicht abgerufen werden',
      rateLimitExceeded: 'Zu viele Anfragen. Bitte warte einen Moment und versuche es erneut.',
    },
    deleteMedia: 'Medium löschen',
    uploadedMedia: 'Medium hochgeladen',
    comingSoon: 'Demnächst verfügbar',
    notNow: 'Nicht jetzt',
    close: 'Schließen',
    saveChanges: 'Änderungen speichern',
    food: 'Essen',
    previous: 'Zurück',
    search: 'Suchen',
    back: 'Zurück',
    cancel: 'Abbrechen',
    loading: 'Lädt...',
    delete: 'Löschen',
    create: 'Erstellen',
    open: 'Geöffnet',
    closed: 'Geschlossen',
    country: 'Land',
    reviews: 'Bewertungen',
    reviews_count: '{{count}} Feinschmecker haben dies probiert',
    showMore: 'Mehr bitte',
    showLess: 'Weniger bitte',
    uploadImage: 'Bild hochladen',
    uploadMedia: 'Medien hochladen',
    sort: 'Sortieren nach',
    loadMore: 'Mehr laden',
    backToHome: 'Zurück zur Startseite',
    next: 'Weiter',
    actions: {
      share: {
        label: 'Teilen',
        copied: 'Link in die Zwischenablage kopiert',
        copyFailed: 'Kopieren des Links fehlgeschlagen',
      },
    },
    exploreMore: 'Mehr Entdecken',
    discoverExperiences: 'Entdecke neue kulinarische Erlebnisse',
    reachedEndOfContent: 'Du hast das Ende dieses Inhalts erreicht',
  },
  statuses: {
    active: 'Aktiv',
    pending: 'Ausstehend',
    rejected: 'Abgelehnt',
  },
  places: {
    radius: 'Wie weit',
    noPlacesFound: 'Noch nichts hier',
    tryAdjustingFilters: 'Versuche, deine Suchoptionen anzupassen',
    locationPermission: {
      title: 'Wo bist du?',
      description:
        'Teile deinen Standort, um köstliche Orte in der Nähe zu finden',
      allow: 'Meinen Standort anzeigen',
    },
    whereDidYouEat: 'Wo hast du das gegessen?',
    searchByLocation: 'Wohin möchtest du gehen?',
    selectPlace: 'Nach einem Ort suchen...',
    yourLocation: 'Dein Standort',
    searchOrUseLocation: 'Suche nach einem Ort oder verwende deinen Standort, um zu beginnen.',
    locationStatus: {
      detecting: 'Standort wird ermittelt...',
      denied: 'Standortzugriff verweigert',
      unavailable: 'Standort nicht verfügbar',
      found: 'Standort gefunden!'
    },
    sort: {
      title: 'Sortieren nach',
      ratingDesc: 'Beste Bewertung', 
      ratingAsc: 'Schlechteste Bewertung',
      distanceAsc: 'Nächstgelegene zuerst',
      distanceDesc: 'Entfernteste zuerst',
      nameAsc: 'Name (A-Z)',
      nameDesc: 'Name (Z-A)',
      reviewCountDesc: 'Meiste Bewertungen',
      reviewCountAsc: 'Wenigste Bewertungen',
      newestFirst: 'Neueste zuerst',
      oldestFirst: 'Älteste zuerst'
    },
    period: {
      title: 'Zeitraum',
      ALL_TIME: 'Gesamter Zeitraum',
      LAST_WEEK: 'Letzte Woche',
      LAST_MONTH: 'Letzter Monat',
      LAST_YEAR: 'Letztes Jahr'
    },
    meta: {
      title: 'Entdecke Restaurants in deiner Nähe',
      description: 'Finde und erkunde die besten Restaurants in deiner Umgebung. Lies Bewertungen, sieh Fotos und entdecke neue kulinarische Erlebnisse.',
      titleWithPlace: 'Beste Lokale in der Nähe von {{place}}',
      descriptionWithPlace: 'Entdecke die besten Restaurants und Lokale in der Nähe von {{place}} im Umkreis von {{radius}}km. Lies Bewertungen, sieh Bewertungen und finde dein nächstes Lieblingslokal.'
    },
    navigation: {
      title: 'Orte',
    },
    detail: {
      error: 'Hoppla! Wir konnten diesen Ort nicht finden. Versuche es erneut?',
      sections: {
        popularFoods: {
          title: 'Am meisten geliebt bei {{place}}',
          description:
            'Diese Gerichte werden von unserer Feinschmecker-Community bei {{place}} am meisten geschätzt. Geordnet nach Bewertungen und Anzahl der Rezensionen.',
          titleWithCity: 'Am meisten geliebt bei {{place}} in {{city}}',
          descriptionWithCity:
            'Diese Gerichte werden von unserer Feinschmecker-Community bei {{place}} in {{city}} am meisten geschätzt. Geordnet nach Bewertungen und Anzahl der Rezensionen.',
        },
        gourmets: {
          title: 'Top-Feinschmecker bei {{place}}',
          description:
            'Triff die Essensliebhaber, die {{place}} am besten kennen. Sie werden nach ihrer Anzahl an Bewertungen und Bewertungen eingestuft.',
          titleWithCity: 'Top-Feinschmecker bei {{place}} in {{city}}',
          descriptionWithCity:
            'Triff die Essensliebhaber, die {{place}} in {{city}} am besten kennen. Sie werden nach ihrer Anzahl an Bewertungen und Bewertungen eingestuft.',
        },
        reviews: {
          title: 'Bewertungen bei {{place}}',
          titleWithCity: 'Bewertungen bei {{place}} in {{city}}',
        },
      },
    },
    emptyState: {
      title: 'Keine Orte gefunden',
      description: '{{username}} hat noch keine Orte bewertet.'
    },
    userMapTitle: '{{username}}s Food-Karte',
    reviewsDrawer: {
      title: 'Bewertungen für {{placeName}}',
      noReviews: 'Noch keine Bewertungen für diesen Ort.',
      viewMore: 'Alle Bewertungen anzeigen',
      addReview: 'Bewertung hinzufügen'
    },
    viewAllVisited: 'Alle Orte, die {{username}} besucht und bewertet hat'
  },
  settings: {
    title: 'Deine Einstellungen',
  },
  home: 'Startseite',
  'review-not-found': 'Kann diese Bewertung nicht finden',
  'go-back': 'Zurück gehen',
  actions: {
    share: 'Freunden erzählen',
  },
  feed: {
    title: 'Deine persönliche kulinarische Reise',
    description:
      'Folge deinen Lieblingsgerichten, Orten und Feinschmeckern für deinen perfekten Food-Feed. Erhalte personalisierte Empfehlungen und verpasse nie wieder eine gute Mahlzeit.',
    discover: 'Entdecken starten',
    personalizedTitle: 'Dein Food-Feed',
    allReviewsTitle: 'Neueste Food-Geschichten',
    personalizedDescription:
      'Sieh dir Bewertungen von Gerichten, Orten und Feinschmeckern an, denen du folgst.',
    joinCommunityDescription:
      'Tritt unserer Community bei, um einen personalisierten Feed basierend auf deinen Interessen zu erhalten.',
    noRelatedReviews:
      'Wir haben noch keine Bewertungen, die zu deinen Interessen passen. Schauen wir uns einige globale Geschichten an!',
    showGlobalFeed: 'Globalen Feed anzeigen',
    myFeed: 'Mein Feed',
    globalFeed: 'Globaler Feed',
    globalDescription:
      'Entdecke die neuesten Food-Geschichten aus der ganzen Welt.',
    noGlobalReviews:
      'Derzeit sind keine globalen Bewertungen verfügbar. Schau bald wieder vorbei!',
    meta: {
      title: 'Dein personalisierter Food-Feed',
      description:
        'Dein personalisierter Food-Feed mit Bewertungen von Gerichten, Orten und Feinschmeckern, denen du folgst.',
      keywords:
        'Food-Feed, personalisierte Empfehlungen, Essensgeschichten, Bewertungen',
    },
    followFoods: {
      title: 'Folge deinen Lieblingsgerichten',
      description:
        'Folge deinen Lieblingsgerichten, um Bewertungen in deinem Feed zu sehen.',
    },
    followPlaces: {
      title: 'Folge deinen Lieblingsorten',
      description:
        'Folge deinen Lieblingsorten, um Bewertungen in deinem Feed zu sehen.',
    },
    followGourmets: {
      title: 'Folge Feinschmeckern',
      description:
        'Folge Feinschmeckern, um ihre Bewertungen in deinem Feed zu sehen.',
    },
  },
  app: {
    actions: 'App-Aktionen',
  },
  download: {
    ios_app: 'iOS-App herunterladen',
    android_app: 'Android-App herunterladen',
  },
  users: {
    title: 'Food-Enthusiasten',
    searchPlaceholder: 'Nach Namen suchen...',
    noResults: 'Keine Food-Enthusiasten gefunden',
    seoTitle: 'Essenskritiker und Bewerter',
    seoDescription:
      'Entdecke Essenskritiker und Bewerter in deiner Nähe. Verbinde dich mit Feinschmeckern, die deine kulinarischen Leidenschaften teilen und entdecke neue Geschmackserlebnisse.',
    seoKeywords:
      'Essenskritiker, Lebensmittelbewerter, kulinarische Experten, Feinschmecker, Feinschmecker',
    navigation: {
      title: 'Foodies',
    },
    stats: {
      followers: 'Follower',
      following: 'Folgt',
      rating: 'Bewertung',
      reviews: 'Bewertungen',
    },
    map: {
      viewMap: 'Food-Karte anzeigen',
      seoTitle: '{{username}}s Food-Karte',
      seoDescription: 'Entdecke die Orte, die {{username}} besucht und bewertet hat, auf ihrer Food-Karte.'
    },
    detail: {
      sections: {
        visitedPlaces: {
          title: '{{username}}s kürzlich besuchte Orte',
          description:
            'Orte, an denen {{username}} seine kulinarischen Erfahrungen geteilt hat',
        },
        likedFoods: {
          title: '{{username}}s Lieblingsgerichte',
          description: 'Gerichte, die {{username}} probiert und bewertet hat',
        },
      },
    },
  },
  foods: {
    title: 'Gerichte',
    meta: {
      title: 'Entdecke Gerichte in deiner Nähe',
      description:
        'Erkunde und entdecke köstliche Gerichte in deiner Umgebung. Durchstöbere Bewertungen, Ratings und Fotos verschiedener Gerichte aus lokalen Restaurants.',
    },
    searchPlaceholder: 'Gerichte suchen...',
    noResults: 'Keine Gerichte gefunden',
    sort: {
      nameAsc: 'Name A-Z',
      nameDesc: 'Name Z-A',
      ratingDesc: 'Höchste Bewertung',
      ratingAsc: 'Niedrigste Bewertung',
      reviewCountDesc: 'Meiste Bewertungen',
      reviewCountAsc: 'Wenigste Bewertungen',
    },
    period: {
      allTime: 'Alle Zeit',
      lastWeek: 'Letzte Woche',
      lastMonth: 'Letzter Monat',
      lastYear: 'Letztes Jahr',
    },
  },
  navigation: {
    home: 'Startseite',
    discover: 'Entdecken',
    popular: 'Beliebt',
    community: 'Community',
    placesNearMe: 'Orte in meiner Nähe',
    foodsNearMe: 'Gerichte in meiner Nähe',
    popularFoodsMonth: 'Beliebte Gerichte des Monats',
    popularPlacesMonth: 'Bestbewertete Orte des Monats',
    mostReviewedPlacesMonth: 'Meistbewertete Orte des Monats',
    myFeed: 'Mein Feed',
    myProfile: 'Mein Profil',
    popularGourmetsMonth: 'Beliebte Feinschmecker des Monats',
    support: 'Support',
    contact: 'Kontakt',
    gourmets: 'Feinschmecker finden',
    privacy: 'Datenschutzrichtlinie',
    terms: 'Allgemeine Geschäftsbedingungen',
  },
  error: {
    pageNotFound: 'Seite nicht gefunden',
    pageNotFoundDescription:
      'Die gesuchte Seite wurde möglicherweise entfernt, umbenannt oder ist vorübergehend nicht verfügbar.',
    needHelp: 'Brauchst du Hilfe?',
    contactUs:
      'Kontaktiere unser Support-Team und wir helfen dir, das zu finden, was du suchst.',
  },
  contact: {
    title: 'Kontaktiere uns',
    name: 'Dein Name',
    email: 'E-Mail-Adresse',
    message: 'Nachricht',
    send: 'Nachricht senden',
    nameRequired: 'Bitte gib deinen Namen ein',
    emailRequired: 'Bitte gib deine E-Mail-Adresse ein',
    emailInvalid: 'Bitte gib eine gültige E-Mail-Adresse ein',
    messageRequired: 'Bitte gib deine Nachricht ein',
    pageTitle: 'Kontakt aufnehmen',
    pageDescription:
      'Hast du Fragen oder brauchst du Hilfe? Wir sind für dich da! Fülle das Formular unten aus oder schreibe uns direkt eine E-Mail.',
  },
  seo: {
    keywords: {
      food: 'Essen',
      cuisine: 'Küche',
      reviews: 'Bewertungen',
      rating: 'Bewertung',
      restaurants: 'Restaurants',
      dining: 'Gastronomie',
    },
    food: {
      title: '{{foodName}} Bewertung',
      description:
        'Entdecken Sie die besten Orte, um {{foodName}} zu essen. Lesen Sie ehrliche Bewertungen und finden Sie heraus, wo Sie das köstlichste {{foodName}} in Ihrer Nähe auf BiteCritic genießen können.',
      defaultDescription:
        'Entdecken Sie {{foodName}} - Bewertungen, Bewertungen und wo Sie das beste {{foodName}} in Ihrer Nähe finden können.',
    },
    place: {
      defaultDescription:
        'Erkunde {{placeName}} - Bewertungen, Ratings und beliebte Gerichte an diesem Ort.',
      cityDescription:
        'Erkunde {{placeName}} in {{cityName}} - Bewertungen, Ratings und beliebte Gerichte an diesem Ort.',
    },
    review: {
      defaultDescription:
        'Lies {{username}}s Bewertung von {{foodName}} bei {{placeName}} - Bewertungen, Fotos und detaillierte Erfahrungen.',
      foodTitle: '{{foodName}} Bewertung bei {{placeName}} - {{rating}}/10',
      placeTitle: '{{placeName}} Bewertung - {{rating}}/10',
      metaDescription:
        'Lesen Sie {{username}}s ausführliche Bewertung von {{foodName}} bei {{placeName}}. Bewertung: {{rating}}/10. Entdecken Sie, was dieses {{type}} besonders macht.',
      authorTitle: '{{username}}s Bewertung von {{foodName}} bei {{placeName}}',
      ratingScale: 'Bewertungsskala: 0-10',
      reviewedType: {
        food: 'Gericht',
        restaurant: 'Restaurant',
        product: 'Produkt',
      },
    },
    user: {
      defaultDescription:
        'Entdecke {{username}}s kulinarische Reise - Bewertungen, Lieblingsgerichte und kulinarische Abenteuer.',
    },
    category: {
      defaultDescription:
        'Erkunde {{categoryName}} Gerichte - entdecke die besten Gerichte, Bewertungen und wo du sie in deiner Nähe findest.',
    },
    meta: {
      siteName: 'BiteCritic',
      defaultTitle: 'BiteCritic - Entdecke und teile Essenserlebnisse',
      defaultDescription:
        'Schließe dich Essensliebhabern weltweit an, um erstaunliche kulinarische Erlebnisse zu entdecken und zu teilen. Finde authentische Bewertungen, Ratings und Fotos von Gerichten in deiner Nähe.',
      defaultKeywords:
        'Essen, Restaurants, Bewertungen, Gastronomie, Küche, Essenskritiker',
    },
  },
  endOfScroll: {
    placesNearMe: 'Orte in der Nähe',
    placesNearMeSubtitle: 'Finde Restaurants und Lokale in deiner Nähe',
    globalFeed: 'Globaler Feed',
    globalFeedSubtitle: 'Sieh, was anderen gefällt',
    findPeople: 'Finde Foodies',
    findPeopleSubtitle: 'Verbinde dich mit anderen Feinschmeckern',
    foodsNearMe: 'Essen in der Nähe',
    foodsNearMeSubtitle: 'Entdecke beliebte Gerichte in deiner Umgebung',
  },
  comments: {
    title: 'Kommentare',
    subtitle: 'Beteilige dich an der Unterhaltung',
    writeComment: 'Schreibe einen Kommentar...',
    submit: 'Veröffentlichen',
    delete: 'Löschen',
    noComments: 'Noch keine Kommentare. Sei der Erste, der kommentiert!',
    loginToComment: 'Bitte melde dich an, um einen Kommentar zu hinterlassen',
    loadMore: 'Mehr laden',
    commentAdded: 'Kommentar erfolgreich hinzugefügt',
    commentError: 'Fehler beim Hinzufügen des Kommentars',
    commentDeleted: 'Kommentar gelöscht',
    deleteError: 'Fehler beim Löschen des Kommentars',
    post: 'Veröffentlichen',
    placeholder: 'Schreibe einen Kommentar...',
  },
  mentions: {
    noUsersFound: 'Keine Benutzer gefunden',
    searchingUsers: 'Benutzer suchen...',
  },
};

export default translations;
